import { ColorUtils } from './colors'

export class Color {
  public r: number
  public g: number
  public b: number
  public a: number

  constructor (colorString: string) {
    colorString = colorString.trim()
    if (colorString.indexOf('rgb') >= 0) {
      const parts = ColorUtils.getRgbaParts(colorString)
      if (!parts) {
        this.r = 0
        this.g = 0
        this.b = 0
        this.a = 1
        return
      }
      this.r = parseInt(parts[1], 10)
      this.g = parseInt(parts[2], 10)
      this.b = parseInt(parts[3], 10)
      this.a = parts[5] ? parseFloat(parts[5]) : 1
      return
    }

    if (colorString.indexOf('#') === 0) {
      if (colorString.length >= 4 && colorString.length <= 5) {
        this.r = parseInt(colorString[1] + colorString[1], 16)
        this.g = parseInt(colorString[2] + colorString[2], 16)
        this.b = parseInt(colorString[3] + colorString[3], 16)
        if (colorString.length === 5) {
          const roundedA = parseInt(colorString[4] + colorString[4], 16)
          this.a = +(roundedA / 255).toFixed(3)
        } else {
          this.a = 1
        }
        return
      }
      if (colorString.length >= 7 && colorString.length <= 9) {
        this.r = parseInt(colorString.substring(1, 3), 16)
        this.g = parseInt(colorString.substring(3, 5), 16)
        this.b = parseInt(colorString.substring(5, 7), 16)
        if (colorString.length === 9) {
          const roundedA = parseInt(colorString.substring(7, 9), 16)
          this.a = +(roundedA / 255).toFixed(3)
        } else {
          this.a = 1
        }
        return
      }
      this.r = 0
      this.g = 0
      this.b = 0
      this.a = 1
      return
    }

    const colors = require('color-name') // eslint-disable-line @typescript-eslint/no-var-requires
    const colorParts = (colors[colorString.toLowerCase()] as string[])
    this.r = parseInt(colorParts[0], 10)
    this.g = parseInt(colorParts[1], 10)
    this.b = parseInt(colorParts[2], 10)
    this.a = 1
  }

  tint (tintRate: number): void {
    this.r = this.calculateTintValue(this.r, tintRate)
    this.g = this.calculateTintValue(this.g, tintRate)
    this.b = this.calculateTintValue(this.b, tintRate)
  }

  private calculateTintValue (colorValue: number, tintRate: number): number {
    return ((255 - colorValue) * (1 - tintRate)) + colorValue
  }

  toHex (): string {
    return ColorUtils.getHexFromRgbParts([this.r.toString(), this.g.toString(), this.b.toString()])
  }

  toRgb (): string {
    return `rgb(${this.r}, ${this.g}, ${this.b})`
  }

  toRgba (): string {
    return `rgba(${this.r}, ${this.g}, ${this.b}, ${this.a})`
  }
}
